module.exports = __webpack_public_path__ + "static/37invgde-30a9d35001181e6346df90a89c562d10.gif";